







































































import {Vue, Component, Watch} from 'vue-property-decorator';
import TextareaCodeEditor from '@/components/TextareaCodeEditor.vue';
import DatetimePicker from '@/components/DatetimePicker.vue';
import {NotificationBanner} from '@/types';
import CancelButton from '@/components/CancelButton.vue';
import GenericButton from '@/components/GenericButton.vue';
import Toast from '@/components/Toast.vue';
import NotificationBannerToast from '@/components/NotificationBannerToast.vue';
import NotificationBannerService from '@/services/notification.banner.service';
import {Action, Getter, Mutation} from 'vuex-class';

@Component({
  components: {NotificationBannerToast, Toast, GenericButton, CancelButton, DatetimePicker, TextareaCodeEditor},
})
export default class AdminNotificationBanners extends Vue {
  @Getter private dismissedBanners: any;
  @Getter private notificationBanner: any;
  @Action private addToastErrorMessage: any;
  @Action private retrieveActiveNotificationBanner: any;
  @Mutation private clearActiveNotificationBanner!: any;
  private banner: NotificationBanner = {
    start_date: new Date(),
    end_date: new Date(),
    message: '',
    severity: 'info',
  };
  private showBanner: boolean = false;
  private saving: boolean = false;
  private editing: boolean = false;
  private activeBanner: NotificationBanner | null = null;

  private async mounted() {
    try {
      await this.retrieveActiveNotificationBanner();
      this.activeBanner = this.notificationBanner;
      // const activeBanner = await NotificationBannerService.getCurrentNotificationBanner();
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(`${err.message}`);
    }

  }
  private onShowBanner(event: boolean) {
    this.showBanner = event;
  }

  private editActiveBanner() {
    this.editing = true;
    this.$set(this, 'banner', this.activeBanner);
  }

  private async saveBanner() {
    this.saving = true;
    this.clearActiveNotificationBanner(this.banner.id);
    try {
      if (this.editing) {
        await NotificationBannerService.updateNotificationBanner(this.banner);
      } else {
        await NotificationBannerService.createNotificationBanner(this.banner);
      }
      const banner = await this.retrieveActiveNotificationBanner();
      Vue.set(this, 'activeBanner', banner);
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(`Error ${this.editing ? 'editing' : 'creating' } notification banner. ${err.message}`);
    } finally {
      this.saving = false;
      this.editing = false;
      this.banner = {
        start_date: new Date(),
        end_date: new Date(),
        severity: 'info',
        message: '',
      };
    }
  }

  private updateDatetime(datetime: string, source: string) {
    Vue.set(this.banner, source, datetime);
  }
}
